export default {
  USER_NOTIFICATION_LIST_REQUEST: 'APP/USER_NOTIFICATION/USER_NOTIFICATION_LIST_REQUEST',
  USER_NOTIFICATION_LIST_SUCCESS: 'APP/USER_NOTIFICATION/USER_NOTIFICATION_LIST_SUCCESS',
  USER_NOTIFICATION_LIST_ERROR: 'APP/USER_NOTIFICATION/USER_NOTIFICATION_LIST_ERROR',
};
